import React, { useEffect, useState } from 'react';
import { Box, Paper, Typography, TextField, Button } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { saveReturnEmail } from '../../../redux/actions/widgetActions';

function SupportEmail() {
  const dispatch = useDispatch();
  const user = useSelector((state) => state?.auth?.user);
  const { savingTerms } = useSelector((state) => state.widget);

  const [returnEmail, setReturnEmail] = useState(user?.returnEmail || '');
  const [emailError, setEmailError] = useState('');

  useEffect(() => {
    if (user?.returnEmail !== undefined) {
      setReturnEmail(user.returnEmail || '');
      setEmailError('');
    }
  }, [user?.returnEmail]);

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleEmailChange = (e) => {
    const value = e.target.value;
    setReturnEmail(value);
    if (value === '') {
      setEmailError('');
    } else if (!validateEmail(value)) {
      setEmailError('Please enter a valid email address');
    } else {
      setEmailError('');
    }
  };

  const isEmailValid = returnEmail.trim() !== '' && validateEmail(returnEmail) && !emailError;

  const handleSaveReturnEmail = () => {
    if (isEmailValid) {
      dispatch(saveReturnEmail(returnEmail));
    }
  };

  return (
    <Box>
      <Paper sx={{ width: '100%', mb: 3, p: 3, borderRadius: 2, boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)' }}>
        <Typography variant="body2" sx={{ fontSize: '16px', fontWeight: 600 }}>
            Return Email
        </Typography>
        <Typography variant="body2" sx={{ color: '#6b7280', mb: 2, fontSize: '14px' }}>
          Set the email address used for customer support communications.
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <TextField
            fullWidth
            label="Support Email"
            type="email"
            value={returnEmail}
            onChange={handleEmailChange}
            placeholder="Enter support email address"
            variant="outlined"
            size="small"
            error={!!emailError}
            helperText={emailError}
            sx={{ '& .MuiOutlinedInput-root': { fontSize: '14px' } }}
          />
          <Button
            variant="contained"
            onClick={handleSaveReturnEmail}
            disabled={savingTerms || !isEmailValid}
            sx={{
              backgroundColor: '#374151',
              color: '#ffffff',
              borderRadius: '8px',
              px: 3,
              py: 0.5,
              textTransform: 'none',
              fontSize: '14px',
              fontWeight: 600,
              '&:hover': { backgroundColor: isEmailValid ? '#1f2937' : '#9ca3af' },
              '&:disabled': { backgroundColor: '#9ca3af', borderColor: '#9ca3af', cursor: 'not-allowed' }
            }}
          >
            {savingTerms ? 'Saving...' : 'Save'}
          </Button>
        </Box>
      </Paper>
    </Box>
  );
}

export default SupportEmail;


